<template>
    <div class="reg position-relative">
        <div class="close position-absolute cursor" @click="handleCloseMail()"></div>
        <!-- 输入邮箱判断 -->
        <div class="mail  position-relative" v-if="flag">
            <div class="title"></div>
            <div class="input-bg position-relative">
                <div class="
                fl-input-bg
                mt-24
                mb-12
              ">
                    <input type="text" class="inpuy-style" autocomplete="off" :placeholder="emailPlaceholder"
                        v-model="account" />
                </div>

                <div class="err-text line-clamp-1  mb-12" v-if="regError">正しいメールアドレスを入力してください</div>
                <div class=" policy-r pb-36">
                    <div class=" position-relative">
                        <input type="checkbox" id="scales" name="scales" checked v-model="policy" />
                        <label for="scales">
                            <div class="agree-size  position-absolute cursor"></div>
                        </label>
                    </div>
                </div>

                <div class="reg-btn cursor " @click="submit()"></div>
                <a href="https://privacy.ujoygames.jp/" class=" policy-text" target="_blank">プライバシーポリシー</a>
                <!-- text -->
                <div class="policy-info">
                    ＊チェックボックスを押す前に、必ず上記のプライバシーポリシー詳細をご確認ください。
                </div>

            </div>
        </div>

        <!-- 点击登录，后台返回的情况、完成预约、重复登入 -->
        <div class="mail-judgment position-relative " v-else>
            <div class="title"></div>
            <div class="err-text" v-if="regCodeFlag"></div>
            <div class="text"></div>
            <div class="d-flex align-items-center justify-content-center mt-24 cursor">
                <div class="twi icon-size mr-16" @click="Twitter_page('twi')"></div>
                <div class="sns icon-size" @click="youtube_page('sns')"></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            flag: true,
            emailPlaceholder: "メルアドを入力してください",
            account: "", // 账号
            regError: false, // 注册信息输入错误
            regCodeFlag: false,
            policy: true,
        }
    },
    methods: {
        Twitter_page(val) {
            this.common.goShare(val);
        },
        youtube_page(val) {
            this.common.goShare(val);
        },
        handleCloseMail() {
            this.$emit('closeMail')
        },
        // 提交
        submit() {
            const reg = new RegExp(
                /^[a-z0-9]+([._\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/
            );
            if (this.account === "" || !reg.test(this.account)) {
                this.regError = true
                return;
            } else if (!this.policy) {
                return;


            } else {

                this.regError = false

                //   邮箱输入正确后，调API
                const reqTime = Math.floor(new Date().getTime() / 1000);
                let source = this.common.getUrlParam("source") || "unknow";
                let target = this.common.getUrlParam("target") || "unknow";

                // 计算signature
                const params = {
                    account: this.account,
                    game: "412",
                    type: 1,
                };

                this.$axios({
                    method: "post",
                    url: "toa/subscribe",
                    data: {
                        account: this.account,
                        game: "412",
                        type: 1,
                        signature: this.common.makeSignature(params, reqTime),
                        reqTime: reqTime,
                        source: source,
                        target: target,
                    },
                    //withCredentials:true, //局部携带cookie
                    headers: {}, //如果需要添加请求头可在这写
                })
                    .then((res) => {
                        this.flag = false
                        if (res.data.code === 0) {
                            this.regCodeFlag = false
                        } else {
                            this.regCodeFlag = true
                        }
                    })
                    .catch((err) => { });
            }
        },
    }
}
</script>
<style lang='scss' >
.reg {
    background: url("../../assets/img/register/reg-bg.png") no-repeat center top;
    background-size: 100% 100%;
    width: 805px;
    height: 488px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    .close {
        background: url("../../assets/img/register/close.png") no-repeat center top;
        background-size: 100% 100%;
        width: 60px;
        height: 60px;
        top: -20px;
        right: -78px;
    }

    .mail {
        top: 29px;

        .title {
            background: url("../../assets/img/register/title.png") no-repeat center top;
            background-size: 100% 100%;
            width: 647px;
            height: 145px;
            margin: 0 auto;
        }

        .input-bg {
            background: url("../../assets/img/register/mail-bg.png") no-repeat center top;
            background-size: 100% 100%;
            width: 452px;
            height: 53px;
            left: 170px;

            input[type="text"] {
                display: inline-block;
                font-size: 18px;
                font-family: KozMinStd-Bold;
                font-weight: bold;
                font-stretch: normal;
                letter-spacing: 2px;
                color: #bab091;
                background: transparent;
                width: 452px;
                height: 53px;
                padding-left: 70px;
            }

            input::placeholder {
                color: #bab091;
            }

        }

        // 错误文字提示
        .err-text {
            letter-spacing: 0px;
            color: #b77d29;
            font-size: 16px;
            font-family: KozMinStd-Bold;
            font-weight: bold;

        }

        .agree-size {
            background: url("../../assets/img/register/agree.png") no-repeat center top;
            background-size: 100% 100%;
            width: 266px;
            height: 18px;
            top: 0;
            left: 30px;
        }

        .reg-btn {
            background: url("../../assets/img/register/btn.png") no-repeat center top;
            background-size: 100% 100%;
            width: 262px;
            height: 66px;
            margin: 0 auto;
        }
    }

    .mail-judgment {
        top: 60px;

        .title {
            background: url("../../assets/img/register/judgment/title.png") no-repeat center top;
            background-size: 100% 100%;
            width: 647px;
            height: 118px;
            margin: 0 auto;
        }

        .err-text {
            background: url("../../assets/img/register/judgment/errtext.png") no-repeat center top;
            background-size: 100% 100%;
            width: 397px;
            height: 31px;
            margin: 24px auto;

        }

        .text {
            background: url("../../assets/img/register/judgment/text.png") no-repeat center top;
            background-size: 100% 100%;
            width: 507px;
            height: 23px;
            margin: 24px auto;
        }

        .twi {
            background: url("../../assets/img/register/judgment/twi.png") no-repeat center top;
            background-size: 100% 100%;
        }

        .sns {
            background: url("../../assets/img/register/judgment/sns.png") no-repeat center top;
            background-size: 100% 100%;
        }

        .icon-size {
            width: 62px;
            height: 63px;
        }
    }

    .policy-text {
        font-size: 14px;
        color: #b8764a;
        font-weight: bold;
        display: block;
        text-align: center;
        text-decoration: underline;
    }

    .policy-info {
        font-size: 12px;
        text-align: center;
        color: #999;
        margin-top: 4px;
        word-wrap: break-word;
        width: 452px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/mainComponents/register.vue